import ElevatorManagement from './ElevatorManagement.vue'

export default ElevatorManagement


// WEBPACK FOOTER //
// ./src/pages/ElevatorManagement/index.js